import { AbstractControl, UntypedFormControl, ValidationErrors } from '@angular/forms';
import { FormlyFieldConfig } from '@ngx-formly/core';

export function UrlValidator(control: UntypedFormControl) {
  // tslint:disable-next-line: max-line-length
  return !control.value || /\b((http|https):\/\/)[^\s()<>]+(?:\([\w\d]+\)|([^[:punct:]\s]|\/?))/
    .test(control.value) ? null : { 'url': true };
}

export function MaxMinValidator(control) {
  const { min, max} = control.controls;
    // if (!min.value && !max.value) {
    //   return {};
    // }
    if (min.value && !max.value) {
      return { fieldMatch: { message: 'Enter maximum value' } };
    }
    if (!min.value && max.value) {
      return { fieldMatch: { message: 'Enter minimum value' } };
    }
    if (Number(min.value) > Number(max.value)){
      return { fieldMatch: { message: 'Minimum value cannot be greater than maximum' } };
    }
    return null;
}

export function PointsValidator(control) {
  if (control.value > 12) {
    return { fieldMatch: { message: 'Points cannot be more than 12' } };
  }
  return null;
}

export function FactorRateValidator(control) {
  const { cost, costType, term} = control.controls;

  if (costType.value === 'factor' && term.value !== '' && term.value < 13 && cost.value > 1.5) {
    return { factorRateCheck: { message: 'Factor Rate cannot be more than 1.5 for a term 12 months or less' } };
  }
  return null;
}

export function PaymentAmountCheck(formGroup) {
  const { paymentAmount, numPayments, payback } = formGroup.controls;
  const paymentAmountValue = paymentAmount?.value;
  const paymentCountValue = numPayments?.value;
  const paybackValue = payback?.value;
  if (!paymentAmountValue) return null;
  if (paybackValue && paymentCountValue) {
    const isLowPayment = paymentAmountValue < (paybackValue / paymentCountValue) * 0.9;
    const isHighPayment = paymentAmountValue > (paybackValue / paymentCountValue) * 1.1;
    if (isLowPayment || isHighPayment)
      return { paymentAmountCheck: {
        message: 'Payment should be \u2248 Payback amount / Number of payments'
      }};
  }
  // Changing validation rule to 15% until we hear back on what it should be
  if (paybackValue) {
    if (paymentAmountValue > Math.ceil(paybackValue * .15)) {
      return { paymentAmountCheck: { message: 'Payment amount should not be more than 5% of the payback amount' }};
    }
  }
  return null;
}
